export default __webpack_public_path__ + "static/media/withdraw-epoint-step5.b2cedbfb.png";